import { render, staticRenderFns } from "./bnvbase.vue?vue&type=template&id=034bb01d&"
import script from "./bnvbase.vue?vue&type=script&lang=js&"
export * from "./bnvbase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports